export const PAYMENT_TYPE = [
  {
    label: 'BATCH_MAILING.BATCHES_TAB.METADATA.PAYMENT_ORDER',
    value: 'payment_order' as 'payment_order',
  },
  {
    label: 'BATCH_MAILING.BATCHES_TAB.METADATA.E_PERSONAL_ACCOUNT',
    value: 'electronic_personal_account' as 'electronic_personal_account',
  },
  {
    label: 'BATCH_MAILING.BATCHES_TAB.METADATA.BY_RECEIPT',
    value: 'advance_receipt' as 'advance_receipt',
  },
  {
    label: 'BATCH_MAILING.BATCHES_TAB.METADATA.BY_DOCUMENT',
    value: 'monetary_document' as 'monetary_document',
  },
  {
    label: 'BATCH_MAILING.BATCHES_TAB.METADATA.COMMITMENT_LETTER',
    value: 'commitment_letter' as 'commitment_letter',
  },
];
export type PaymentType = (typeof PAYMENT_TYPE)[number]['value'];
export const PAYMENT_TYPE_MAP = new Map<string, string>(
  PAYMENT_TYPE.map((item) => [String(item.value), item.label]) as any
) as any;
